/**
 * ...
 * @author Robert Lombardo, Wakefield Studios ( rob@wakefield-studios.com )
 */
const YesNoNode = require('../YesNoNode');
const BattleCalc = require('../../BattleCalc');
const Q_at_board_edge = require('./Q_at_board_edge');
const UseAbility = require('../UseAbility');

const Q_high_MP = function (actor, battleState) {
  const node = new YesNoNode(actor, battleState);

  node.sleightOfHand = BattleCalc.getEquippedAbility(actor, 'sleight_of_hand');
  node.slam = BattleCalc.getEquippedAbility(actor, 'slam');

  node.branches[node.NO] = new Q_at_board_edge(actor, battleState);

  if (node.sleightOfHand) {
    node.branches[node.YES] = new UseAbility(actor, 'sleight_of_hand');
  } else {
    node.branches[node.YES] = node.branches[node.NO];
  }

  const originalDispose = node.dispose;
  node.dispose = function() {
    node.sleightOfHand = null;
    node.slam = null;
    originalDispose.call(node);
  };

  node.yesNoEvalFunction = function (target) {
    return this.sleightOfHand && target.mp > this.sleightOfHand.potency * 0.65;
  };

  return node;
};
module.exports = Q_high_MP;
